import React from "react";
import PropTypes from "prop-types";
import { NotificationLogo } from "../../assets/icons";
import iphoneImg from "../../images/iPhone.png";
import { Typography } from "@mui/material";
import {
  BACKGROUND_REPEAT_NO_REPEAT,
  BACKGROUND_SIZE_CONTAIN,
  FONT_WEIGHT_BOLD,
} from "../../config/styles";

const NotificationStimulator = ({ message }) => {
  const showMessage = message?.substring(0, 25) || "[Your message]";
  return (
    <div className="notification-stimulator">
      <div
        style={{
          backgroundImage: `url(${iphoneImg})`,
          backgroundSize: BACKGROUND_SIZE_CONTAIN,
          width: "300px",
          backgroundRepeat: BACKGROUND_REPEAT_NO_REPEAT,
        }}
      >
        <div className="message-container">
          <div className="message-content">
            <div className="message-logo"><NotificationLogo /></div>
            <div>
              <Typography variant="h6" sx={{ fontWeight: FONT_WEIGHT_BOLD }}>
                Skiply
              </Typography>
              <Typography variant="h6">
                {showMessage}
              </Typography>
            </div>
          </div>
          <Typography variant="h6" sx={{ opacity: "0.5" }}>
            Now
          </Typography>
        </div>
      </div>
    </div>
  );
};

NotificationStimulator.propTypes = {
  message: PropTypes.string.isRequired,
};

export default NotificationStimulator;
